import R from 'ramda';
import React, {PropTypes as pt} from 'react';
import MultipleCheckbox from './MultipleCheckbox';

class CheckboxSet extends React.Component {
    handleChange = (value, checked) => {
        const func = checked ? R.union : R.without;
        this.props.onChange(
            this.props.name,
            func([value], this.props.value)
        );
    };

    render() {
        const {name, data, value, disabled, label} = this.props;
        return (
            <div className="row">
                <label className="col-md-2 control-label">
                    {label}
                </label>
                <div className="col-md-10">
                    <div className="row">
                        {R.map(
                            item => (
                                <MultipleCheckbox
                                    className="col-md-6"
                                    key={item.key}
                                    name={item.value}
                                    label={item.value}
                                    onChange={this.handleChange}
                                    disabled={disabled}
                                    value={item.key}
                                    checked={R.contains(item.key, value)}
                                />
                            ),
                            data,
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

CheckboxSet.propTypes = {
    name: pt.string.isRequired,
    data: pt.arrayOf(pt.shape({})).isRequired,
    value: pt.arrayOf(pt.oneOfType([pt.string, pt.number])).isRequired,
    disabled: pt.bool.isRequired,
    label: pt.string.isRequired,
    onChange: pt.func.isRequired,
};

CheckboxSet.defaultProps = {
    disabled: false,
    value: [],
};

export default CheckboxSet;



// WEBPACK FOOTER //
// ./src/incab/common/components/form/CheckboxSet.jsx